import { render, staticRenderFns } from "./ConfigWebsiteCatalogueArticleListingAll.vue?vue&type=template&id=c5fe4144"
import script from "./ConfigWebsiteCatalogueArticleListingAll.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueArticleListingAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports